import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { device } from "../../../styles/device";

const PostAuthorContainer = styled.div`
    font-size: 19px;
    line-height: 1.21053;
    font-weight: 700;
    margin-left: auto;
    margin-right: auto;
    margin-top: 32px;

        &::before {
            content: '';
            display: inline-block;
            height: 1px;
            width: 100%;
            background-color: #d0d0d0;
            margin-bottom: 42px;
        }

        &::after {
            content: '';
            display: inline-block;
            height: 1px;
            width: 100%;
            background-color: #d0d0d0;
            margin-top: 42px;
        }

        h2 {
            font-size: 24px;
            font-weight: 800;
            margin: 0;
        }
`;

const AvatarContainer = styled.div`
    height: 70px;
    width: 70px;
    min-width: 70px;
    position: relative;
    border-radius: 50%;
    img {
        border-radius: 50%;
    }
`;
const PostAuthorGrid = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 20px;

    @media ${device.laptop} {
        align-items: center;
        flex-direction: row;
        column-gap: 20px;
        row-gap: 0;
    }
    div {
        font-size: 14px;
        line-height: 23px;
        font-weight: 500;
        box-sizing: border-box;
        word-wrap: break-word;
        display: inline-block;
        vertical-align: top;

        strong {
            font-size: 19px;
            line-height: 25px;
            font-weight: 800;
            margin-bottom: 5px;
            margin-top: 0;
            letter-spacing: -0.02em;
        }
        p {
            margin: 0;
        }

        a {
            color: ${(props) => props.theme.colors.buttonPrimary};
        }
    }
`

export const PostAuthor = ({ author }) => {
    return (
        <PostAuthorContainer className='component-content'>
            {/*  <h2>Pressekontakte</h2> */}
            <PostAuthorGrid>
                {
                    author.avatar?.url != null &&
                    <AvatarContainer>
                        <Image
                            layout='fill'
                            alt={`Cover Image for ${author.name}`}
                            src={author.avatar.url}
                        />
                    </AvatarContainer>
                }
                <div>
                    <strong>Autor</strong>
                    <p>{author.name}</p>
                    <a href={"mailto:" + author.email}>{author.email}</a>
                </div>
                {author?.description != null &&
                    <div>
                        <p> {author.description}</p>
                    </div>
                }

            </PostAuthorGrid>
        </PostAuthorContainer >
    );
};
